import {HttpHeaders} from "@angular/common/http";

export class HttpClientUtils {

  public static NO_LOAD_HTTP_HEADER = new HttpHeaders().set('no-load', 'true');

}
